// extracted by mini-css-extract-plugin
export var createdDate = "_n1-1";
export var divider = "_n1-2";
export var headerDivider = "_n1-3";
export var messagesCard = "_n1-0";
export var messagesContainer = "_n1-6";
export var messagesContainerWrapper = "_n1-4";
export var showLeftPanelButton = "_n1-8";
export var topButtons = "_n1-7";
export var withPadding = "_n1-5";